import { Link } from 'react-router-dom';

export const Footer = () => {
  return (
    <footer className="bg-[#0A0E27] border-t border-[#2A2F4A] mt-20">
      <div className="container mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-xl font-bold gradient-text mb-4">Video Analyzer IA</h3>
            <p className="text-gray-400 text-sm">
              Analise vídeos do YouTube com inteligência artificial
            </p>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4">Explore</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><Link to="/" className="hover:text-white transition">Home</Link></li>
              <li><Link to="/dashboard" className="hover:text-white transition">Dashboard</Link></li>
              <li><Link to="/dashboard/history" className="hover:text-white transition">Histórico</Link></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4">Legal</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><Link to="/privacy" className="hover:text-white transition">Privacidade</Link></li>
              <li><Link to="/terms" className="hover:text-white transition">Termos</Link></li>
            </ul>
          </div>
        </div>
        
        <div className="mt-8 pt-8 border-t border-[#2A2F4A] text-center text-sm text-gray-400">
          <p>© 2025 Video Analyzer IA. Todos os direitos reservados.</p>
        </div>
      </div>
    </footer>
  );
};

